import {FC} from 'react';
import cn from 'classnames';
import {CERTIFICATE_TYPE_OPTIONS, type CertificateType} from '../../model/certificateType';
import styles from './CertificateTypeStep.module.css';

type Props = {
	value: CertificateType;
	onChange: (value: CertificateType) => void;
};

export const CertificateTypeStep: FC<Props> = ({value, onChange}) => (
	<div className={styles.root}>
		<h2 className={styles.title}>Выберите тип справки</h2>

		<div className={styles.list} role="radiogroup" aria-label="Тип справки">
			{CERTIFICATE_TYPE_OPTIONS.map((option) => {
				const selected = option.value === value;

				return (
					<button
						key={option.value}
						type="button"
						role="radio"
						aria-checked={selected}
						className={styles.row}
						onClick={() => onChange(option.value)}
					>
						<span className={styles.label}>{option.label}</span>
						<span className={cn(styles.radio, selected && styles.radioSelected)} aria-hidden>
							{selected ? <span className={styles.radioDot} /> : null}
						</span>
					</button>
				);
			})}
		</div>
	</div>
);
